import React from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from "react-router-dom";
import logoSrc from "../../img/logo.png";
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import ErrorDisplay from '../error-display/error-display';
import useForm from '../../hooks/useForm';

import './login-signup-form.css';

const LoginSignupForm = ({ isLogin }) => {
    // eslint-disable-next-line no-unused-vars
    const { login, signup, error } = useAuth();
    const navigate = useNavigate();
    
    // Validate form fields
    const validate = (values) => {
        const errors = {};
        if (!values.email) {
            errors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(values.email)) {
            errors.email = 'Email is invalid';
        }
        
        if (!values.password) {
            errors.password = 'Password is required';
        } else if (values.password.length < 6) {
            errors.password = 'Password must be at least 6 characters';
        }
        
        return errors;
    };
    
    // Handle form submission
    const handleFormSubmit = async (values) => {
        if (isLogin) {
            await login(values.email, values.password);
        } else {
            await signup(values.email, values.password);
        }
        // Redirect to home page on success
        navigate('/');
    };
    
    // Use our custom form hook
    const {
        values,
        errors,
        touched,
        loading,
        submitError,
        handleChange,
        handleBlur,
        handleSubmit
    } = useForm({
        initialValues: { email: '', password: '' },
        onSubmit: handleFormSubmit,
        validate
    });

    return (
        <form className="col-md-6 justify-content-center text-center" onSubmit={handleSubmit}>
            <img className="mb-4" src={logoSrc} alt="" width="100" height="100" />
            {isLogin
                ? <h1 className="h3 mb-3 fw-normal">Please sign in</h1>
                : <h1 className="h3 mb-3 fw-normal">Registration</h1>
            }

            <ErrorDisplay message={submitError} />

            <div className="form-floating">
                <input
                    type="email"
                    className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
                    id="email"
                    name="email"
                    placeholder="name@example.com"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    disabled={loading}
                />
                <label htmlFor="email">Email address</label>
                {touched.email && errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                )}
            </div>
            <div className="form-floating">
                <input
                    type="password"
                    className={`form-control ${touched.password && errors.password ? 'is-invalid' : ''}`}
                    id="password"
                    name="password"
                    placeholder="Password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    disabled={loading}
                />
                <label htmlFor="password">Password</label>
                {touched.password && errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                )}
            </div>

            {isLogin && (
                <div className="checkbox my-3">
                    <label>
                        <input type="checkbox" value="remember-me" className="m-2" disabled={loading}/>
                        Remember me
                    </label>
                </div>
            )}
            
            <div className="form-floating my-3">
                {isLogin
                    ? <p>Don't have an account? <Link to="/register">Register</Link></p>
                    : <p>Already have an account? <Link to="/login">Login</Link></p>
                }
            </div>
            
            <button
                type="submit"
                className="w-100 btn btn-lg btn-primary"
                disabled={loading}
            >
                {loading && <LoadingSpinner size="small" className="me-2" />}
                {isLogin
                    ? 'Sign In'
                    : 'Register'
                }
            </button>
        </form>
    );
};

LoginSignupForm.propTypes = {
  isLogin: PropTypes.bool,
};

export default LoginSignupForm;